import '../reset.css';
import '../style.css';
import '../scripts/common.js';
import {initIframeResize} from './_inIFrame.js';

initIframeResize();
